import axios from "axios";
import { API_STATUS } from "./constants";
const companySignupApi = process.env.REACT_APP_COMPANYSIGNUP_API_CONFIG;

export const companySignup = async (data) => {
    try {
        console.log("data", data);
        const path = "/company/signup";
        const response = await axios.post(companySignupApi + path, data);
        console.log(response);
        return response;
    } catch (error) {
        return 'Unable to signup company';
    }
};

export const sendSupportEmail = async (data) => {
    try {
        console.log("data", data);
        const path = "/sendSupportEmail";
        const response = await axios.post(companySignupApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to send Support Email';
    }
};

export const getModuleFeature = async () => {
    try {
        const path = "/plans";
        const response = await axios.get(companySignupApi + path);
        console.log("plans", response);
        return response.data;
    } catch (error) {
        return {
            data: [],
            status: API_STATUS.error,
            message: error.message,
        };
    }
};

export const companyNameValidation = async (companyName) => {
    try {
        let path = "/check/company";
        path += companyName ? `?company_name=${companyName}` : '';
        const response = await axios.get(companySignupApi + path);
        return response;
    } catch (error) {
        return {
            data: [],
            status: API_STATUS.error,
            message: error.message,
        };
    }
};

export const userNameValidation = async (user_name) => {
    try {
        let path = "/check/user";
        path += user_name ? `?user_name=${user_name}` : '';
        const response = await axios.get(companySignupApi + path);
        return response;
    } catch (error) {
        return {
            data: [],
            status: API_STATUS.error,
            message: error.message,
        };
    }
};

export const referralEmailValidation = async (referral_email) => {
    try {
        let path = "/check/referral";
        path += referral_email ? `?referred_email=${referral_email}` : '';
        const response = await axios.get(companySignupApi + path);
        return response;
    } catch (error) {
        return {
            data: [],
            status: API_STATUS.error,
            message: error.message,
        };
    }
};

export const getUserRoles = async () => {
    const path = '/roles';
    try {
        const response = await axios.get(companySignupApi + path);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const updateUserRole = async (data) => {
    const path = '/company/user';
    console.log(data);
    try {
        const response = await axios.put(companySignupApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const addUser = async (data) => {
    const path = '/company/user';
    console.log(data);
    try {
        const response = await axios.post(companySignupApi + path, data);
        console.log(response);
        return response;
    } catch (error) {
        return 'Unable to add user';
    }
};

export const createLeads = async (data) => {
    try {
        console.log("data", data);
        let path = `/leads`;
        console.log("path", companySignupApi + path);
        const response = await axios.post(companySignupApi + path, data);
        return response;
    } catch (error) {
        return "Unable to create new lead";
    }
};

export const emailVerificationStatus = async (data) => {
    try {
        const path = '/user/verification';
        const response = await axios.post(companySignupApi + path, data);
        return response;
    } catch (error) {
        return {
            statusCode: 400,
            message: 'Unable to get verification status. Please try again later',
        };
    }
};

export const activateUser = async (username) => {
    try {
        const path = `/user/confirm?username=${username}`;
        const response = await axios.put(companySignupApi + path);
        return response;
    } catch (error) {
        return {
            statusCode: 400,
            message: 'Unable to change status. Please try again later',
        };
    }
}

export const deactivateUser = async (username) => {
    try {
        const path = `/user/deactivate?username=${username}`;
        const response = await axios.put(companySignupApi + path);
        return response;
    } catch (error) {
        return {
            statusCode: 400,
            message: 'Unable to change status. Please try again later',
        };
    }
}